import Vue from 'vue';

Vue.component('media-library', require('./MediaLibrary.vue').default);
Vue.component('media-filters', require('./MediaFilters.vue').default);
Vue.component('media-grid', require('./MediaGrid.vue').default);
Vue.component('media-preview', require('./MediaPreview.vue').default);
Vue.component('media-upload-zone', require('./MediaUploadZone.vue').default);
Vue.component('media-usage-list', require('./MediaUsageList.vue').default);

// Parent-window media picker modal opener (window.galaxyMediaPicker) — used by
// the canvas utils.image "Bladeren" button via window.parent.
require('./mediaPicker.js');
